var map = {
	"./Anubis.PNG": 8930,
	"./Archiver.PNG": 3380,
	"./AshOni.PNG": 1316,
	"./BlackBride.PNG": 3179,
	"./BloodyCryptZombie.PNG": 3253,
	"./BurntCryptZombie.PNG": 5859,
	"./Centipede.PNG": 3096,
	"./Clarice.PNG": 7581,
	"./Clown.PNG": 9307,
	"./Clubfoot.PNG": 1634,
	"./Creep.PNG": 9309,
	"./CrimsonLady.PNG": 7362,
	"./Crocodile.PNG": 3025,
	"./CryptStalkerWhite.PNG": 3630,
	"./CryptZombie.PNG": 7911,
	"./Feeler.PNG": 3528,
	"./FrostFoot.PNG": 8207,
	"./HunterPigman.PNG": 43,
	"./JokerSmiley.PNG": 7745,
	"./Leech.PNG": 8911,
	"./MamaSwampDog.PNG": 8663,
	"./Marionette.PNG": 8539,
	"./Miner.PNG": 5215,
	"./Mosquito.PNG": 661,
	"./Nameless.PNG": 2138,
	"./Necreph.PNG": 7266,
	"./Ouphis.PNG": 9075,
	"./PartyGoer.PNG": 1969,
	"./PartyGoerCyan.PNG": 7887,
	"./PartyGoerGreen.PNG": 7737,
	"./PartyGoerPink.PNG": 5738,
	"./PartyGoerYellow.PNG": 6527,
	"./Pigman.PNG": 5759,
	"./PigmanV2.PNG": 5883,
	"./Ptahmes.PNG": 999,
	"./Rat.PNG": 8731,
	"./RedOni.PNG": 4346,
	"./ScareCrow.PNG": 2650,
	"./ScareCrowV2.PNG": 6063,
	"./SmileyV2.PNG": 5718,
	"./SmolderWickerman.PNG": 2252,
	"./SwampDog.PNG": 2441,
	"./TrenchStalker.PNG": 7115,
	"./Vampire.PNG": 7874,
	"./Wickerman.PNG": 5787,
	"./WickermanV2.PNG": 7896,
	"./WinterWitch.PNG": 8206,
	"./Witch.PNG": 7107,
	"./smiley.PNG": 6279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1962;